import { render, staticRenderFns } from "./CompilaQuestionarioScoredDiabetePuglia.vue?vue&type=template&id=a2a12950&"
import script from "./CompilaQuestionarioScoredDiabetePuglia.vue?vue&type=script&lang=js&"
export * from "./CompilaQuestionarioScoredDiabetePuglia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports